import { Tag } from "@asurion-core/mx-asurion-ui-react";
import { Contact, DetailsContainer, DetailsWrapperContainer, HighlightText, TotalCostIcon } from "@ubif/components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { FlexContactWrapperContainer, FlexNameWrapperContainer } from "./FlexContainers";
import { QuickSearchCustomerDetailsProps } from "./QuickSearchCustomerDetails";
type QuickSearchPriceQuoteDetailsProps = Omit<
  QuickSearchCustomerDetailsProps,
  "firstName" | "lastName" | "customerId" | "onClick"
> & {
  quoteId: number;
  totalCost: string;
  minCost: string;
  maxCost: string;
};

export const QuickSearchPriceQuoteDetails = ({
  fullName,
  email,
  phone,
  canEmail,
  canSms,
  canCall,
  highlightText,
  preferredContactLabel,
  quoteId,
  totalCost,
  minCost,
  maxCost
}: QuickSearchPriceQuoteDetailsProps) => {
  const { t } = useTranslation("root-config");
  return (
    <StyledLink to={`/check-in/price-check?quoteId=${quoteId}&searchTerm=GlobalSearch`}>
      <StyledQuickSearchPriceQuoteDetails>
        <TotalCostIcon className="icon" size={30}></TotalCostIcon>
        <DetailsContainer>
          <FlexNameWrapperContainer>
            <HighlightText
              highlightText={highlightText}
              wholeText={`${t("GlobalSearch.PriceQuoteId", { quoteId })} |`}
            />
            <HighlightText highlightText={highlightText} wholeText={fullName} className="fs-mask" />
          </FlexNameWrapperContainer>
          <FlexContactWrapperContainer>
            {email ? (
              <Contact
                icon="email"
                text={email}
                canEmail={canEmail}
                preferredContactLabel={preferredContactLabel}
                className="fs-mask"
              />
            ) : null}
            {phone ? (
              <Contact
                icon="call"
                text={phone}
                canSms={canSms}
                canCall={canCall}
                canEmail={canEmail}
                preferredContactLabel={preferredContactLabel}
                className="fs-mask"
              />
            ) : null}
            {quoteId ? <Tag text={`${t("GlobalSearch.PriceQuoteId", { quoteId })}`} type={"gray"} /> : null}
            {totalCost ? <Tag text={`${t("GlobalSearch.PriceQuoteTotalCost", { totalCost })}`} type={"gray"} /> : null}
            {minCost ? <Tag text={`${t("GlobalSearch.PriceQuoteMinCost", { minCost })}`} /> : null}
            {maxCost ? <Tag text={`${t("GlobalSearch.PriceQuoteMaxCost", { maxCost })}`} /> : null}
          </FlexContactWrapperContainer>
        </DetailsContainer>
      </StyledQuickSearchPriceQuoteDetails>
    </StyledLink>
  );
};

const StyledQuickSearchPriceQuoteDetails = styled(DetailsWrapperContainer)`
  background-color: var(--aui-on-primary);

  &:hover {
    background-color: var(--aui-outline-soft);
    border-radius: 0.5rem;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;
